import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from './api';

export const fetchUsers = createAsyncThunk(
  'users/fetchUsers',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`/auth/users/`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data.message || 'Failed to fetch users.');
    }
  }
);

export const addUser = createAsyncThunk(
  'users/addUser',
  async (newUser, { rejectWithValue }) => {
    try {
      
      const response = await api.post(`/auth/users/`, newUser);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data.message || 'Failed to add user.');
    }
  }
);

export const deleteUser = createAsyncThunk(
  'users/deleteUser',
  async (userId, { rejectWithValue }) => {
    try {
      
      await api.delete(`/auth/users/${userId}/`);
      return userId;
    } catch (error) {
      return rejectWithValue(error.response.data.message || 'Failed to delete user.');
    }
  }
);

export const updateUser = createAsyncThunk(
  'users/updateUser',
  async ({ userId, userData }, { rejectWithValue }) => {
    try {
      
      const response = await api.patch(`/auth/users/${userId}/`, userData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data.message || 'Failed to update user.');
    }
  }
);

// Create Slice
const usersSlice = createSlice({
  name: 'users',
  initialState: {
    users: [],
    user: [],
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.users = action.payload;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Failed to fetch users.';
      })
      .addCase(addUser.fulfilled, (state, action) => {
        state.users.push(action.payload);
      })
      .addCase(addUser.rejected, (state, action) => {
        state.error = action.payload || 'Failed to add user.';
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        state.users = state.users.filter(user => user.id !== action.payload);
      })
      .addCase(deleteUser.rejected, (state, action) => {
        state.error = action.payload || 'Failed to delete user.';
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        const index = state.users.findIndex(user => user.id === action.payload.id);
        if (index !== -1) {
          state.users[index] = action.payload;
        }
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.error = action.payload || 'Failed to update user.';
      });
  }
});

export default usersSlice.reducer;